<template>
    <div v-title :data-title="websiteData.title !== undefined ? websiteData.title : '广东昊心科技有限责任公司'">
        <el-container>
            <el-header class="header" height="80px">
                <Header class="animate__animated animate__fadeInDown" @logoError="logoError" :websiteData="websiteData" :value.sync="isMenu" :index.sync="activeIndex"
                        :hxClassifyList="hxClassifyList" :menuShow="true"/>
                <el-drawer
                        title="菜单"
                        :visible.sync="isMenu"
                        direction="ltr"
                        size="70%">
                    <el-menu>
                        <el-menu>
                            <el-menu-item @click="menuClick" :index="index + ''" style="margin: 0 20px"
                                          v-for="(item,index) in hxClassifyList.slice(0,5)" :key="index">
                                <span slot="title">{{item.title}}</span>
                            </el-menu-item>
                        </el-menu>
                    </el-menu>
                </el-drawer>
            </el-header>
            <el-main style="padding: 0;overflow-y: hidden">
                <Main></Main>
            </el-main>
            <el-footer style="background: #0094ff;height: 100%;padding: 20px 0;overflow-x: hidden">
                <Footer :websiteData="websiteData"/>
            </el-footer>
        </el-container>

        <el-backtop></el-backtop>
    </div>
</template>

<script>
    import Header from "@/components/header/index"
    import Main from "@/components/main/index"
    import Footer from "@/components/footer/index"
    import {listEnableHxClassify} from "@/api/classify";
    import {getWebsiteInfo} from "@/api/set";
    import Vue from 'vue'

    export default {
        name: 'HomeView',
        components: {
            Header,
            Footer,
            Main
        },
        data() {
            return {
                isMenu: false,
                activeIndex: null,
                hxClassifyList: [],
                websiteData: {},
            }
        },
        created() {
            // 获取分类导航
            listEnableHxClassify().then(response => {
                this.hxClassifyList = response.rows
            })

            let data = sessionStorage.getItem('websiteData')
            if(data){
                this.websiteData = JSON.parse(data)
            }else {
                // 获取网站参数
                getWebsiteInfo().then(response => {
                    this.websiteData = response.data
                    sessionStorage.setItem('websiteData', JSON.stringify(this.websiteData));
                })
            }
        },
        methods: {
            // logo加载失败
            logoError(){
                this.websiteData.logo = "https://pic.imgdb.cn/item/64c0e1fc1ddac507cc03196d.png"
            },
            menuClick(e) {
                let menu
                if (e.index === '0') {
                    menu = document.getElementById("menu0")
                } else if (e.index === '1') {
                    menu = document.getElementById("menu1")
                } else if (e.index === '2') {
                    menu = document.getElementById("menu2")
                } else if (e.index === '3') {
                    menu = document.getElementById("menu3")
                } else if (e.index === '4') {
                    menu = document.getElementById("menu4")
                }

                this.activeIndex = e.index

                window.scrollTo({
                    top: menu.offsetTop - 100,
                    behavior: "smooth"
                });
                this.isMenu = false
            },
        }
    }
</script>

<style lang="scss" scoped>
    .header {
        display: flex;
        align-items: center;
        padding: 0;
    }
</style>
